import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryShowcase from './components/CategoryShowcase';
import BenefitsGrid from './components/BenefitsGrid';
import ArticlePreview from './components/ArticlePreview';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import TestimonialSection from './components/TestimonialSection';
import ArticleGrid from './components/ArticleGrid';
import FAQSection from './components/FAQSection';
import CTABanner from './components/CTABanner';

export default function Home() {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://vigorbuy.help';

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        {/* 1. Hero */}
        <HeroSection />

        {/* 2. Category Showcase */}
        <CategoryShowcase />

        {/* 3. Benefits Grid */}
        <BenefitsGrid />

        {/* 4. Editorial Split + Article Preview */}
        <ArticlePreview />

        {/* 5. Comparison Table */}
        <ComparisonSection />

        {/* 6. Safety Center */}
        <SafetySection />

        {/* 7. Testimonial */}
        <TestimonialSection />

        {/* 8. 9 SEO Articles Grid */}
        <ArticleGrid />

        {/* 9. FAQ */}
        <FAQSection />

        {/* 10. Final CTA */}
        <CTABanner />
      </main>

      <Footer />

      {/* FAQPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: 'Is the VigorBuy Spreadsheet free to use?', acceptedAnswer: { '@type': 'Answer', text: 'Yes, the VigorBuy Spreadsheet is completely free to browse. You can explore all 14 product categories, compare sellers, and read buying guides without any cost. Purchases are made on the main platform separately.' } },
              { '@type': 'Question', name: 'How often is the VigorBuy Spreadsheet updated?', acceptedAnswer: { '@type': 'Answer', text: 'The VigorBuy Spreadsheet is updated daily to reflect current product availability, accurate pricing, and verified seller information. Products updated within the last 48 hours are most likely to be in stock.' } },
              { '@type': 'Question', name: 'Is the VigorBuy Spreadsheet safe to use?', acceptedAnswer: { '@type': 'Answer', text: 'Yes, the spreadsheet is safe to use. It serves as a product discovery and comparison tool. Financial transactions occur on the secure main VigorBuy platform, not within the spreadsheet itself. Additionally, curated seller verification and safety guides further protect buyers.' } },
              { '@type': 'Question', name: 'How do I find products on the VigorBuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'Simply browse the 14 curated categories including Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more. Each category contains pre-vetted products with seller ratings, price ranges, and direct links. You can also use the category dropdown menu for quick navigation.' } },
              { '@type': 'Question', name: 'Can beginners use the VigorBuy Spreadsheet?', acceptedAnswer: { '@type': 'Answer', text: 'Absolutely. The VigorBuy Spreadsheet is designed to be beginner-friendly with a clean, intuitive layout. Step-by-step buying guides, seller verification checklists, and safety tutorials are available to help first-time international shoppers navigate with confidence.' } },
            ],
          }),
        }}
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'VigorBuy',
            url: origin,
            description: 'Curated product spreadsheet helping buyers discover trusted products, compare sellers, and shop smarter internationally.',
            sameAs: ['https://kaspreadsheet.com'],
          }),
        }}
      />
    </div>
  );
}